import React, { useEffect } from 'react';
import { useTour } from '../../store/context/tour.context';

/**
 * TourInitializer - Ensures tour state matches localStorage
 * Must be rendered INSIDE TourProvider to access useTour context
 * Prevents main ProductTour from showing if user has already seen it
 */
const TourInitializer = ({ children }) => {
  const { endTour } = useTour();

  // Check localStorage and sync tour state on mount
  useEffect(() => {
    const hasSeen = localStorage.getItem('haix_tour_completed') === 'true';
    if (hasSeen) {
      endTour(); // Ensure tour state matches localStorage
    }
  }, [endTour]);

  return children;
};

export default TourInitializer;
